import Vue from 'vue'
import PracticeGamesUser from './components/practice_games_user_app'
import $ from 'jquery'

export function embedPracticeGame() {
  if ($('.practice-games-markup-application').length > 0) {
    $('.practice-games-markup-application').each(function() {
      const gameSlug = $(this).data('slug')

      const xhr = {
        dataType: 'json',
        method: 'GET',
        url: '/practice_games'
      }

      SOPHIA.sendXHR(xhr).then(response => {
        const currentGame = response.items.find(obj => {
          return obj.slug === gameSlug
        })

        const xhr = {
          method: 'GET',
          url: '/practice_games/' + currentGame.id
        }
        SOPHIA.sendXHR(xhr).then(response => {
          new Vue({
            el: '.practice-games-markup-application',
            render: h => h(PracticeGamesUser, { props: { game: response } })
          })
        })
      })
    })
  }
}
